/**
 * A voice for the builder preview: analyser-shaped bins that rise and fall
 * like speech, so the call stage moves the way it will on a real call
 * without a microphone or a session.
 */
export function previewVoiceData(): () => Uint8Array {
  const bins = new Uint8Array(128);
  return () => {
    const t = performance.now() / 1000;
    // Syllables: a fast envelope under a slower phrase envelope.
    const phrase = 0.55 + 0.45 * Math.sin(t * 1.3);
    const syllable = Math.max(0, Math.sin(t * 9.5) * Math.sin(t * 4.1));
    for (let i = 0; i < bins.length; i++) {
      const shape = Math.max(0, 1 - i / 48);
      const grain = 0.6 + 0.4 * Math.sin(t * 7 + i * 1.7);
      const level = shape * grain * phrase * (0.2 + 0.8 * syllable);
      bins[i] = Math.round(255 * Math.min(1, level));
    }
    return bins;
  };
}
